import { memo } from 'react';

import { SegmentedControlRow } from '~/components/ShareModal/components/SegmentedControlRow';
import { useShareBoardDesign } from '~/components/SharePrivateBoardModal/ShareBoardDesignProvider';

/** Corner rounding (thumbnailRadius) segmented control, bound to the board design context. */
export const ShareBoardDesignCornerRoundingRow = memo(() => {
  const { thumbnailRadiusOptions, selectedThumbnailRadiusOption, handleSelectThumbnailRadius } = useShareBoardDesign();

  return (
    <SegmentedControlRow
      data-testid="SHARE_BOARD_DESIGN_CORNER_ROUNDING_ROW"
      label="Corner rounding"
      onSelect={handleSelectThumbnailRadius}
      options={thumbnailRadiusOptions}
      selectedOption={selectedThumbnailRadiusOption}
    />
  );
});

ShareBoardDesignCornerRoundingRow.displayName = 'ShareBoardDesignCornerRoundingRow';
